// src/pages/AdminDashboard.jsx
import React, { useEffect, useState } from 'react';
import adminAxios from '../adminAxios';
import AdminNavbar from '../components/AdminNavbar';

const AdminDashboard = () => {
  const [activeTab, setActiveTab] = useState('users');
  const [users, setUsers] = useState([]);
  const [tickets, setTickets] = useState([]);
  const [editUser, setEditUser] = useState(null);
  const [viewDetailsUser, setViewDetailsUser] = useState(null);
  const [balances, setBalances] = useState({ USDT: '', BTC: '', ETH: '', INR: '' });
  const [search, setSearch] = useState('');

  useEffect(() => {
    fetchUsers();
    fetchTickets();
  }, []);

  const fetchUsers = async () => {
    const token = localStorage.getItem('adminToken');
    try {
      const res = await adminAxios.get('/users', {
        headers: { Authorization: `Bearer ${token}` }
      });
      setUsers(res.data.users);
    } catch (err) {
      console.error('Failed to fetch users:', err);
    }
  };

  const fetchTickets = async () => {
    const token = localStorage.getItem('adminToken');
    try {
      const res = await adminAxios.get('/tickets', {
        headers: { Authorization: `Bearer ${token}` }
      });
      setTickets(res.data.tickets);
    } catch (err) {
      console.error('Failed to fetch tickets:', err);
    }
  };

  const updateTicketStatus = async (id, status) => {
    const token = localStorage.getItem('adminToken');
    try {
      await adminAxios.patch(`/ticket/${id}`, { status }, {
        headers: { Authorization: `Bearer ${token}` }
      });
      fetchTickets();
    } catch (err) {
      console.error('Failed to update ticket status:', err);
    }
  };

  const openEditModal = (user) => {
    setEditUser(user);
    setBalances({
      USDT: user.balances?.USDT || 0,
      BTC: user.balances?.BTC || 0,
      ETH: user.balances?.ETH || 0,
      INR: user.balances?.INR || 0
    });
  };

  const updateBalances = async () => {
    const token = localStorage.getItem('adminToken');
    try {
      await adminAxios.patch(`/user/${editUser._id}/balance`, { balances }, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setEditUser(null);
      fetchUsers();
    } catch (err) {
      console.error('Failed to update balances:', err);
    }
  };

  const handleKycStatus = async (id, status) => {
    const token = localStorage.getItem('adminToken');
    try {
      await adminAxios.patch(`/user/${id}/kyc`, { isKycVerified: status }, {
        headers: { Authorization: `Bearer ${token}` }
      });
      fetchUsers();
    } catch (err) {
      console.error('Failed to update KYC status:', err);
    }
  };

  const handleBankStatus = async (id, status) => {
    const token = localStorage.getItem('adminToken');
    try {
      await adminAxios.patch(`/user/${id}/bank`, { isBankVerified: status }, {
        headers: { Authorization: `Bearer ${token}` }
      });
      fetchUsers();
    } catch (err) {
      console.error('Failed to update bank verification:', err);
    }
  };

  const filteredUsers = users.filter(user =>
    user.email.toLowerCase().includes(search.toLowerCase()) ||
    user.firstName.toLowerCase().includes(search.toLowerCase()) ||
    user.lastName.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-6">Admin Dashboard</h1>
      <div className="flex space-x-4 mb-4">
        <button
          onClick={() => setActiveTab('users')}
          className={`px-4 py-2 rounded ${activeTab === 'users' ? 'bg-blue-600 text-white' : 'bg-gray-200'}`}
        >
          Users
        </button>
        <button
          onClick={() => setActiveTab('support')}
          className={`px-4 py-2 rounded ${activeTab === 'support' ? 'bg-blue-600 text-white' : 'bg-gray-200'}`}
        >
          Support Tickets
        </button>
      </div>

      {activeTab === 'users' && (
        <>
          <input
            type="text"
            value={search}
            onChange={e => setSearch(e.target.value)}
            placeholder="Search by name or email..."
            className="mb-4 px-4 py-2 border rounded w-full max-w-md"
          />
          <div className="overflow-x-auto">
            <table className="min-w-full bg-white border rounded">
              <thead>
                <tr>
                  <th className="border p-2">Name</th>
                  <th className="border p-2">Email</th>
                  <th className="border p-2">INR</th>
                  <th className="border p-2">USDT</th>
                  <th className="border p-2">KYC</th>
                  <th className="border p-2">Bank</th>
                  <th className="border p-2">Actions</th>
                </tr>
              </thead>
              <tbody>
                {filteredUsers.map((user) => (
                  <tr key={user._id}>
                    <td className="border p-2">{user.firstName} {user.lastName}</td>
                    <td className="border p-2">{user.email}</td>
                    <td className="border p-2">₹{user.balances?.INR?.toFixed(2)}</td>
                    <td className="border p-2">{user.balances?.USDT?.toFixed(2)}</td>
                    <td className="border p-2 space-y-1">
                      <span>{user.isKycVerified ? '✅ Verified' : '❌ Not Verified'}</span>
                      <div className="flex gap-1">
                        <button onClick={() => handleKycStatus(user._id, true)} className="bg-green-600 text-white text-xs px-2 py-1 rounded">Approve</button>
                        <button onClick={() => handleKycStatus(user._id, false)} className="bg-red-600 text-white text-xs px-2 py-1 rounded">Reject</button>
                      </div>
                    </td>
                    <td className="border p-2 space-y-1">
                      <span>{user.isBankVerified ? '✅ Verified' : '❌ Not Verified'}</span>
                      <div className="flex gap-1">
                        <button onClick={() => handleBankStatus(user._id, true)} className="bg-green-600 text-white text-xs px-2 py-1 rounded">Approve</button>
                        <button onClick={() => handleBankStatus(user._id, false)} className="bg-red-600 text-white text-xs px-2 py-1 rounded">Reject</button>
                      </div>
                    </td>
                    <td className="border p-2 space-y-1">
                      <button onClick={() => openEditModal(user)} className="bg-blue-600 text-white text-xs px-3 py-1 rounded">Edit</button>
                      <button onClick={() => setViewDetailsUser(user)} className="bg-purple-600 text-white text-xs px-3 py-1 rounded">View</button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      )}

      {activeTab === 'support' && (
        <div className="overflow-x-auto mt-8">
          <table className="min-w-full bg-white border rounded">
            <thead>
              <tr>
                <th className="border p-2">Ticket #</th>
                <th className="border p-2">Email</th>
                <th className="border p-2">Subject</th>
                <th className="border p-2">Message</th>
                <th className="border p-2">Status</th>
                <th className="border p-2">Actions</th>
              </tr>
            </thead>
            <tbody>
              {tickets.map((ticket, index) => (
                <tr key={ticket._id}>
                  <td className="border p-2">#{index + 1}</td>
                  <td className="border p-2">{ticket.email}</td>
                  <td className="border p-2">{ticket.subject}</td>
                  <td className="border p-2">{ticket.message}</td>
                  <td className="border p-2 capitalize">{ticket.status}</td>
                  <td className="border p-2 space-x-1">
                    {["open", "in progress", "resolved", "closed"].map((status) => (
                      <button
                        key={status}
                        onClick={() => updateTicketStatus(ticket._id, status)}
                        className="bg-blue-600 text-white text-xs px-2 py-1 rounded mb-1"
                      >
                        {status}
                      </button>
                    ))}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {editUser && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div className="bg-white p-6 rounded shadow-lg w-96">
            <h2 className="text-xl font-semibold mb-4">Edit Balances</h2>
            {['INR', 'USDT', 'BTC', 'ETH'].map((coin) => (
              <div key={coin} className="mb-2">
                <label className="block text-sm font-medium">{coin}</label>
                <input
                  type="number"
                  className="w-full p-2 border rounded"
                  value={balances[coin]}
                  onChange={(e) =>
                    setBalances({ ...balances, [coin]: parseFloat(e.target.value) || 0 })
                  }
                />
              </div>
            ))}
            <div className="flex justify-end gap-2 mt-4">
              <button onClick={() => setEditUser(null)} className="px-4 py-2 bg-gray-400 text-white rounded">Cancel</button>
              <button onClick={updateBalances} className="px-4 py-2 bg-green-600 text-white rounded">Update</button>
            </div>
          </div>
        </div>
      )}

      {viewDetailsUser && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div className="bg-white p-6 rounded shadow-lg w-[450px] max-h-[90vh] overflow-y-auto">
            <h2 className="text-xl font-semibold mb-4">User Details</h2>
            <div className="space-y-2 text-sm">
              <p><strong>Full Name:</strong> {viewDetailsUser.firstName} {viewDetailsUser.lastName}</p>
              <p><strong>Email:</strong> {viewDetailsUser.email}</p>
              <p><strong>Phone:</strong> {viewDetailsUser.contact}</p>
              <p><strong>Country:</strong> {viewDetailsUser.country}</p>
              <p><strong>KYC:</strong> {viewDetailsUser.idProofType} - {viewDetailsUser.idProofNumber || 'N/A'}</p>
              <p><strong>PAN:</strong> {viewDetailsUser.panCardNumber || 'N/A'}</p>
              <hr />
              <p><strong>Bank:</strong> {viewDetailsUser.bankName || 'N/A'}</p>
              <p><strong>Account Holder:</strong> {viewDetailsUser.accountHolder || 'N/A'}</p>
              <p><strong>Account Number:</strong> {viewDetailsUser.accountNumber || 'N/A'}</p>
              <p><strong>Branch:</strong> {viewDetailsUser.branch || 'N/A'}</p>
              <p><strong>IFSC:</strong> {viewDetailsUser.ifsc || 'N/A'}</p>
            </div>
            <div className="mt-4 text-right">
              <button onClick={() => setViewDetailsUser(null)} className="px-4 py-2 bg-red-500 text-white rounded">Close</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AdminDashboard;
